import { Injectable } from "@angular/core";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as jsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { GeometryUnion } from "@arcgis/core/geometry/types";
import * as ArcGIS from "@terraformer/arcgis";
import * as WKT from "@terraformer/wkt";

@Injectable({
    providedIn: "root"
})
export class TerraformerService {

    wktToArcgis(wkt: string, spatialReference: SpatialReference) {
        const geoJson = this.wktToGeoJson(wkt);
        const arcGisJson = this.geojsonToArcGIS(geoJson, spatialReference);
        return jsonUtils.fromJSON(arcGisJson);
    }

    arcGisToWkt(arcGisObject: GeometryUnion): string {
        const geoJson = this.arcgisToGeoJSON(arcGisObject);
        return this.geojsonToWKT(geoJson);
    }

    geojsonToWKT(geoJson: GeoJSON.GeoJSON): string {
        return WKT.geojsonToWKT(geoJson);
    }

    wktToGeoJson(wkt: string): GeoJSON.GeoJSON {
        return WKT.wktToGeoJSON(wkt);
    }

    arcgisToGeoJSON(arcGisObject: GeometryUnion): GeoJSON.GeoJSON {
        return ArcGIS.arcgisToGeoJSON(arcGisObject);
    }

    geojsonToArcGIS(geoJson: GeoJSON.GeoJSON, spatialReference: SpatialReference) {
        const geom = ArcGIS.geojsonToArcGIS(geoJson);
        geom.spatialReference = spatialReference;
        return geom;
    }
}
